import React from "react";
import MerchPartnerDynamic from "./merchPartnerContent--";

function MerchPartner() {
    return <div className="container" id='containerPartner'>
                 <div className="containerCentered">
                    <div className="Title">
                        <h2 id="merchPartner">Merchandise Partner</h2>
                        {/* <h3>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</h3>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p> */}
                    </div>
                    <div className="image-gallery-container">
      <div className="image-gallery">





<div
  className="secondary-banner"
  style={{
    marginTop: '20px',
    marginBottom: '20px',
    overflow: 'hidden', // necesario para que el video no se desborde al agrandarse
  }}
>
  <a href="https://sportsfan.co.nz/" target="_blank" rel="noopener noreferrer">
    <video
      src="img/banner.mp4"
      poster="img/topBanner.png"
      style={{
        width: '100%',
        transition: 'transform 0.3s ease',
        display: 'block',
      }}
      autoPlay
      loop
      muted
      playsInline
      onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
      onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
    ></video>
  </a>
</div>






<div
  className="secondary-banner"
  style={{
    marginTop: '20px',
    marginBottom: '20px',
    overflow: 'hidden',
    width: '100%',
  }}
>
  <a href="https://shop.nzfootball.co.nz" target="_blank" rel="noopener noreferrer">
    <img
      src="img/home/nzfbanner.jpg"
      alt="NZ Football Shop"
      style={{ width: '100%', height: 'auto', display: 'block' }}
    />
  </a>
</div>


       
      </div>
    </div>
                    {/* <div className="merPartnerContent">
                        <MerchPartnerDynamic />
                    </div> */}
                </div>
           </div>
}

export default MerchPartner;







